import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { Box, Text } from 'edenred-ui';

import TransferUnfulfilledRequestSummary from '@epi-components/TransferUnfulfilledRequestSummary/TransferUnfulfilledRequestSummary';
import { BoxOval } from '@epi-shared/components';
import { getActiveBenefits } from '@epi-actions/api';
import { selectActiveBenefits } from '@epi-selectors/benefitGroupSettings';
import { LUNCH } from '@epi-constants/benefitTypes';
import { ToggleEstimationButton } from '@epi-pages/TransferPage/LoadCompanyAccount/components/ToggleEstimationButton/ToggleEstimationButton';

import { AmountField } from '../AmountField';

export const TransferMoneyEnterAmount = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  const amountFieldRef = useRef<HTMLInputElement>();
  const [estimationVisible, setEstimationVisible] = useState(true);
  const activeBenefits = useSelector(selectActiveBenefits);

  const isLunariBenefitActive = !!activeBenefits.find(
    elem => elem === LUNCH.toLowerCase()
  );

  const toggleEstimationVisibility = () =>
    setEstimationVisible(!estimationVisible);

  useEffect(() => {
    amountFieldRef?.current?.focus();
  }, []);

  useEffect(() => {
    dispatch(getActiveBenefits());
  }, []);

  return (
    <Box minHeight={200} p={2} bgcolor={theme.primaryBackColorLight10}>
      <Box display="flex" alignItems="center" px={8} py={4}>
        <BoxOval text="1" bgColor={theme.gray0} />
        <Box flex={1}>
          <Box position="relative" py={5}>
            <Text>{t('transfer_money.enter_amount')}</Text>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" flex={1}>
          <Box maxWidth={200} mr={2}>
            <AmountField ref={amountFieldRef} />
          </Box>
        </Box>
      </Box>
      <Box px={8}>
        {isLunariBenefitActive && (
          <ToggleEstimationButton
            estimationVisible={estimationVisible}
            toggleEstimationVisibility={toggleEstimationVisibility}
          />
        )}
        {estimationVisible && <TransferUnfulfilledRequestSummary />}
      </Box>
    </Box>
  );
};
